function parseSampleRate(value: string | undefined, fallback: number): number {
  const parsed = Number.parseFloat(value ?? "");
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function getSentryEnvironment(): string {
  return process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? "development";
}

export function getServerSentryDsn(): string | undefined {
  return process.env.SENTRY_DSN?.trim() || undefined;
}

export function getClientSentryDsn(): string | undefined {
  return process.env.NEXT_PUBLIC_SENTRY_DSN?.trim() || process.env.SENTRY_DSN?.trim() || undefined;
}

export function getBaseSentryOptions(dsn: string) {
  return {
    dsn,
    environment: getSentryEnvironment(),
    tracesSampleRate: parseSampleRate(process.env.SENTRY_TRACES_SAMPLE_RATE, 0.1),
    sendDefaultPii: false,
  };
}

export function getServerSentryOptions() {
  const dsn = getServerSentryDsn();
  if (!dsn) {
    return null;
  }

  return {
    ...getBaseSentryOptions(dsn),
    profilesSampleRate: parseSampleRate(process.env.SENTRY_PROFILES_SAMPLE_RATE, 0.1),
  };
}

export function getEdgeSentryOptions() {
  const dsn = getServerSentryDsn();
  if (!dsn) {
    return null;
  }

  return getBaseSentryOptions(dsn);
}

export function getClientSentryOptions() {
  const dsn = getClientSentryDsn();
  if (!dsn) {
    return null;
  }

  return getBaseSentryOptions(dsn);
}
